var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn--big btn--white-bg nav__button nav__button--content header__button",attrs:{"href":_vm.domain + _vm.prefix + '/auth/login'}},[_vm._v("\n    "+_vm._s(_vm.$lang('app.login'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }